import React from 'react';
import { Modal } from 'react-bootstrap';

interface OffboardModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onChangeEndDate: (e: React.ChangeEvent<HTMLInputElement>) => void;
  user: any;
  end_date: string;
  formErrors: { end_date?: string };
  isLoading: boolean;
}

const OffboardModal: React.FC<OffboardModalProps> = ({
  show,
  onClose,
  onConfirm,
  onChangeEndDate,
  user,
  end_date,
  formErrors,
  isLoading,
}) => {
  return (
    <Modal show={show} onHide={onClose} backdropClassName='bg-opacity-1' centered>
      <Modal.Header closeButton>
        <Modal.Title>Offboard {user?.full_name}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{padding:'20px'}}>
        <div className='fs-6'>
          Set the employee's last working day below to initiate the offboarding. Please
          note that your employee will be noticed to complete the assignment checklist.
        </div>
        <div className='fv-row mb-2 mt-7'>
          <label className=' fw-bold fs-6 mb-2'>End Date</label>
          <input
            placeholder='Enter Checklist Date'
            type='date'
            className={`form-control mb-3 mb-lg-0 w-100 ${formErrors.end_date ? 'is-invalid' : ''}`}
            name='end_date'
            value={end_date || user?.end_date}
            onChange={onChangeEndDate}
            autoComplete='off'
          />
          {formErrors.end_date && (
            <div className='invalid-feedback'>{formErrors.end_date}</div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer style={{padding:'16px'}}>
        <button type='button' className='btn btn-light fs-6 me-2' onClick={onClose}>
          Close
        </button>
        {isLoading ? (
          <button
            className='btn btn-sm fs-6'
            disabled
            style={{
              backgroundColor: '#0E9F6E',
              color: '#fff',
              height: '40px',
              borderRadius: '4px',
              transition: 'background-color 0.3s',
            }}
          >
            Offboarding Employee...
            <span className='spinner-border spinner-border-sm align-middle m-2'></span>
          </button>
        ) : (
          <button
            className='btn btn-sm fs-6'
            onClick={onConfirm}
            style={{
              backgroundColor: '#0E9F6E',
              color: '#fff',
              height: '40px',
              borderRadius: '4px',
              transition: 'background-color 0.3s',
            }}
          >
            Offboard Employee
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default OffboardModal; 